import { InputHTMLAttributes } from 'react'
import { FieldError } from 'react-hook-form'

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  title: string
  className?: string
  hideDefaultOption?: boolean
  register?: any
  errors?: FieldError
  options: { value: string; text: string }[]
}

export function CustomerSelect({
  title,
  register,
  className,
  options,
  hideDefaultOption = false,
  ...props
}: IProps) {
  return (
    <div className={`${className}`}>
      <p>{title}</p>
      <select {...register} {...props}>
        {!hideDefaultOption && (
          <option value="" disabled selected>
            Nada selecionado...
          </option>
        )}
        {options.map((op) => {
          return (
            <option key={op.value} value={op.value}>
              {op.text}
            </option>
          )
        })}
      </select>
    </div>
  )
}
